import * as React from 'react';

import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {pages} from './consts';

export function SchedulerOnboardingModal() {
    const {onClose} = useOpenableModal(OpenableModals.SCHEDULER_ONBOARDING_MODAL);

    return (
        <OnboardingModal
            lastButtonText='Done'
            // @ts-expect-error
            pages={pages}
            onClose={onClose}
            onFinish={onClose}
            maxHeight={600}
        />
    );
}
